import React, { useEffect, useState } from "react";
import Cliente from "../../components/agent/cliente/Cliente";
import {  Box, Card, CardContent, Typography,  useTheme ,Grid } from "@mui/material";
import Cuentas from "../../components/agent/cuenta/Cuentas";
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import TopBar from "../../components/agent/TopBar";
import apiInstance from "../../services/ServiceApi";
import AlertModal from "../../components/utilities/AlertModal";
 
 

const Agente = () => {
  const theme = useTheme();
  const location = useLocation();
  const [campaignDiscadorExists, setCampaignDiscadorExists] = useState(false);
  const [lineaNegocio, setLineaNegocio] = useState(null);
  const [guardoGestion, setGuardoGestion] = useState(false);

  const [formulario, setFormulario] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const handleCloseModalAlert = () => {    setModalOpen(false); };
  const parsed = queryString.parse(location.search);
  const uniqueid = parsed.uniqueid || parsed.callid || -1;

  const campaign = parsed.campaign;
  const vendor_id = parsed.vendor_id;
  const user = parsed.user;
  const phone_number = parsed.phone_number;
  const [idCliente, setIdCliente] = useState(null);
  //const tipo_gestion = parsed.tipo_gestion;
  const manejarIdCliente = (idCliente) => {
    setIdCliente(idCliente);
  };
  useEffect(() => {
    if (campaign) {
      apiInstance.get('/campania/', {params:{ campania: campaign} })
        .then(response => {
            setCampaignDiscadorExists(true);  
            console.log(response.data);
            setLineaNegocio(response.data.linea_negocio);
            setFormulario(response.data.formulario);
            setModalOpen(false)
        
        })
        .catch(error => {
          setCampaignDiscadorExists(false);
          setModalOpen(true)
        });
    }
  }, [campaign]);
   
  return (
    <Box mb={2} sx={{ flexGrow: 1, padding: 0, mx: [1, 2, 3], bgcolor: theme.palette.background.default, overflow: 'auto' }}>
      <TopBar asesor={user} anexo={10} numeroMarcado={phone_number} />
      <Grid container spacing={2} mb={2}>
        {guardoGestion ? (
          <Grid item xs={12} md={12}>
            <Card>
              <CardContent>
                <Typography color="textSecondary" gutterBottom>
                  Se guardó la gestión correctamente, espere una siguiente llamada para seguir gestionando
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ) : campaignDiscadorExists ? (
          <>
            <Grid item xs={12} md={12}>
              <Cliente identificador={vendor_id} lineaNegocio={lineaNegocio} manejarIdCliente={manejarIdCliente} />
            </Grid>
            { idCliente && (
              <>
                <Grid item xs={12} md={12}>
                  <Cuentas
                    identificador={vendor_id}
                    id_linea_negocio={lineaNegocio.id}
                    codigo_llamada={uniqueid}
                    codigo_usuario={user}
                    numero_contactado={phone_number}
                    campaign={campaign}
                    idCliente={idCliente}
                    formulario={formulario}
                    setGuardoGestion={setGuardoGestion}
                  />
                </Grid>
               
              </>
            )}
          </>
        ) : (
          <AlertModal
          open={modalOpen}
          onClose={handleCloseModalAlert}
          alertType={'error'}
          message={`No se encontró la campaña ${campaign}`}
        />
        )}
      </Grid>
    </Box>
  );
};

export default Agente;
